module.exports = __webpack_public_path__ + "static/media/add_clients_import.d0652796.svg";